'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _pacomo = require('utils/pacomo');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FieldHelpErrorText = function FieldHelpErrorText(_ref) {
    var touched = _ref.touched,
        error = _ref.error,
        helpText = _ref.helpText;
    return _react2.default.createElement(
        'div',
        null,
        helpText && _react2.default.createElement(
            'div',
            { className: 'help-field' },
            helpText
        ),
        touched && error && !_lodash2.default.isEmpty(error) && _react2.default.createElement(
            'div',
            { className: 'error-field' },
            _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'error-mark' },
                    '!'
                ),
                error
            )
        )
    );
};

exports.default = (0, _pacomo.pacomoTransformer)(FieldHelpErrorText);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/forms/FieldHelpErrorText.js
// module id = 1342
// module chunks = 0